import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import Drawer from "../components/Drawer";
import MenuTabs from "../components/MenuTabs";
import classes from "../css/FantasyGamePage.module.css";
import axios from "axios";
import { baseUrl, weeklyMatchesApi } from "../api/api";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import MatchLayout from "../components/MatchLayout";
import Loader from "../components/Loader";
import { useSelector } from "react-redux";
import date from "../helpers/date";

const FantasyGamePage = () => {
  const [matches, setMatches] = useState([]);
  const [todayMatches, setTodayMatches] = useState([]);
  const [tomorrowMatches, setTomorrowMatches] = useState([]);
  const [loading, setLoading] = useState(false);

  const { lang } = useSelector((state) => state.langSlice);

  const fetchWeeklyMatchesFromBackend = async (loader) => {
    try {
      if (loader.loading == true) {
        setLoading(true);
      }
      const res = await axios.get(`${baseUrl}${weeklyMatchesApi}`, {
        timezone: moment.tz.guess(),
      });
      // setMatches(res.data.response);
      if (res?.data?.response?.length > 0) {
        setMatches(
          res?.data?.response.filter(
            (match) =>
              date(match?.time)?.date != "Today" &&
              date(match?.time)?.date != "Tomorrow"
          )
        );
        setTodayMatches(
          res?.data?.response.filter(
            (match) => date(match?.time)?.date == "Today"
          )
        );
        setTomorrowMatches(
          res?.data?.response.filter(
            (match) => date(match?.time)?.date == "Tomorrow"
          )
        );
      }
      setLoading(false);
    } catch (error) {
      // toast.error(
      //   error?.data || error?.data?.message || "Something Went Wrong!"
      // );
      console.log(error, "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWeeklyMatchesFromBackend({ loading: true });
    const intervalId = setInterval(() => {
      if (!document.hidden) {
        fetchWeeklyMatchesFromBackend({ loading: false });
      }
    }, 15000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Layout active={4} hideMenu={true}>
      <Drawer active={4} />
      <div className={classes.container}>
        <MenuTabs activeIndex={2} />

        {loading ? (
          <Loader />
        ) : (
          <div className={classes.matches_container}>
            <div className={classes.heading_container}>
              <h1 className={classes.heading}>
                {lang == "english"
                  ? "Create Fantasy Team And Win Prizes"
                  : lang == "spanish"
                  ? "Crea un equipo de fantasía y gana premios"
                  : lang == "french"
                  ? "Créez une équipe fantastique et gagnez des prix"
                  : lang == "arabic"
                  ? "أنشئ فريقًا خياليًا واربح الجوائز"
                  : "Create Fantasy Team And Win Prizes"}
              </h1>
            </div>
            {todayMatches?.map((match, index) => {
              return <MatchLayout match={match} key={index} />;
            })}
            {tomorrowMatches?.map((match, index) => {
              return <MatchLayout match={match} index={index} />;
            })}
            {matches?.length > 0 ? (
              matches?.map((match, index) => {
                return <MatchLayout match={match} key={index} />;
              })
            ) : (
              <div className={classes.message_box}>
                <p className={classes.message}>
                  {lang == "english"
                    ? "There are no upcoming matches currently in this week.."
                    : lang == "spanish"
                    ? "No hay próximos partidos actualmente en esta semana."
                    : lang == "french"
                    ? "Il n’y a pas de matchs à venir cette semaine."
                    : lang == "arabic"
                    ? "لا توجد مباريات قادمة حاليا في هذا الأسبوع.."
                    : "There are no upcoming matches currently in this week.."}
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default FantasyGamePage;
